import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TableLayout from "../../../components/TableLayout";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../hooks/dataHandler";
import {
  CONTENT_DELETE,
  CONTENT_LIST,
  CONTENT_STATUS_CHANGE,
} from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import {
  activeInActiveArr,
  activeInactiveOptions,
} from "../../../utilities/const";
import TableActions from "../../../components/Common/TableActions";
import Toggle from "../../../components/Common/Toggle";
import moment from "moment";

const ContentPage = () => {
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: CONTENT_LIST,
  });

  const column = [
    {
      head: "Sr. no.",
      accessor: "srNo",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    { head: "Pages", accessor: "name" },
    {
      head: "Status",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 rounded ${
            item?.status === "Active"
              ? "bg-success text-white"
              : "bg-danger text-white"
          }`}
        >
          {item?.status === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      head: "Created At",
      accessor: "createdAt",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <>{moment(item.date_created_utc).format("MM-DD-YYYY , HH:MM")}</>
      ),
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      //
      component: (item) => (
        <TableActions
          editUrl={`/content-page/edit/${item._id}`}
          // setDeleteModel={() =>
          //   setDeleteModel({ show: true, dumpId: item._id })
          // }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() =>
          deleteHandler(() => CONTENT_DELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="contentPage py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                Content Page Managment
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                {/* <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Link
                        to={"/content-page/add"}
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout loader={loader} data={data} column={column} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContentPage;
